// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".square-filter[data-v-824638d6]{display:flex;flex-direction:column;flex:1}.square-filter>p[data-v-824638d6]{color:#fff;line-height:100%;padding-bottom:4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
